// @ts-check
import { Link } from '@material-ui/core';
import { SPACES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import { Flex, Padding } from 'components/base/layout-components';
import purpleDude from 'images/characters/purple-dude.svg';
import svgLogo from 'images/logos/linearb-logo.svg';
import styled from 'styled-components';

const Logo = styled.img`
  width: 10rem;
  padding-top: ${SPACES['big']};
`;

const DudeBubble = styled.div`
  width: 110px;
  height: 44px;
  border-radius: 35px;
  background-color: ${getColor('catskillWhite')};
  position: relative;
  margin-left: 15px;
  padding-top: 17px;
  padding-left: 20px;
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    top: 32px;
    left: -14px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-right: 25px solid ${getColor('catskillWhite')};
    transform: rotate(-16deg);
  }
`;

const LogoWithDudeWrapper = ({
  children,
  dataCy,
  withLogo = true,
  withDude = true
}) => (
  <Flex
    direction='column'
    justify='space-between'
    items='center'
    width='100%'
    height='100%'
  >
    <Flex direction='column' items='center' width='100%' data-cy={dataCy}>
      {withLogo ? (
        <Padding r='small'>
          <Logo src={svgLogo} />
        </Padding>
      ) : null}
      {children}
    </Flex>
    {withDude ? (
      <Flex>
        <img src={purpleDude} alt='' />
        <DudeBubble>
          Visit <Link>LinearB.io</Link> to learn more about us
        </DudeBubble>
      </Flex>
    ) : null}
  </Flex>
);

export default LogoWithDudeWrapper;
